<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chap"><a id="page_v">Contents</a></h2><a id="page_v">
</a><p class="tochla"><a id="page_v"></a><a href="#/05_ack">Editor’s Acknowledgments</a></p>
<p class="tochla"><a href="#/06_con">Contributors</a></p>
<p class="tochlb"><a href="#/08_intro">Introduction: Edgy Ethnography in a Little Big Place</a> \ Fran Markowitz</p>
<p class="tochp"><b><span href="#/09_pt01" title="Link target outside of Sample">Part I. Confrontations and Conversions</span></b></p>
<p class="tochl"><span href="#/10_ch01" title="Link target outside of Sample"><b>1</b>    How Christian Pilgrims Made Me Israeli</span> \ Jackie Feldman</p>
<p class="tochl"><span href="#/11_ch02" title="Link target outside of Sample"><b>2</b>    Mission Not Accomplished: Negotiating Power Relations and Vulnerability among Messianic Jews in Israel</span> \ Tamir Erez</p>
<p class="tochl"><span href="#/12_ch03" title="Link target outside of Sample"><b>3</b>    Doing Dimona: An Americanist Anthropologist in an Africanized Israel</span> \ John L. Jackson Jr.</p>
<p class="tochp"><b><span href="#/13_pt02" title="Link target outside of Sample">Part II. State Categories and Global Flows</span></b></p>
<p class="tochl"><span href="#/14_ch04" title="Link target outside of Sample"><b>4</b>    Seeking Truth in Hip-Hop Music and Hip-Hop Ethnography</span> \ Uri Dorchin</p>
<p class="tochl"><span href="#/15_ch05" title="Link target outside of Sample"><b>5</b>    The State of the Jewish Family: Eldercare as a Practice of Corporeal Symbiosis by Filipina Migrant Workers</span> \ Keren Mazuz</p>
<p class="tochl"><span href="#/16_ch06" title="Link target outside of Sample"><b>6</b>    Diasporas Collide: Competing Holocausts, Imposed Whiteness, and the Seemingly Jewish Non-Jew Researcher in Israel</span> \ Gabriella Djerrahian</p>
<p class="tochp"><b><span href="#/17_pt03" title="Link target outside of Sample">Part III. Fieldwork to the Point of Worry</span></b></p>
<p class="tochl"><span href="#/18_ch07" title="Link target outside of Sample"><b>7</b>    Traveling between Reluctant Neighbors: Researching with Jews and Bedouin Arabs in the Northern Negev</span> \ Emily McKee</p>
<p class="tochl"><span href="#/19_ch08" title="Link target outside of Sample"><b>8</b>    On the Matter of Return to Israel/Palestine: Autoethnographic Reflections</span> \ Jasmin Habib</p>
<p class="tochl"><span href="#/20_ch09" title="Link target outside of Sample"><b>9</b>    Some Kind of Masochist? Fieldwork in Unsettling Territory</span> \ Joyce Dalsheim</p>
<p class="tochll"><a id="page_vi"></a><span href="#/21_ch10" title="Link target outside of Sample"><b>10</b>    The Impurities of Experience: Researching Prostitution in Israel</span> \ Hilla Nehushtan</p>
<p class="tochll"><span href="#/22_ch11" title="Link target outside of Sample"><b>11</b>    Falling in Love with a Criminal? On Immersion and Self-Restraint</span> \ Virginia R. Dominguez</p>
<p class="tochlb"><span href="#/23_ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_toc.vue?17bae5f7